export default __webpack_public_path__ + "static/media/btnUtopians.5bad6906.png";